<template>
  <div class="user-container" ref="usercontainer" style="height:100%;overflow: hidden">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item
      ><a href="javascript:;">文章管理</a>
      </el-breadcrumb-item>
      <el-breadcrumb-item>视频发布</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card" style="margin-top: 20px;height:100%;overflow-y: scroll" >
      <el-form ref="form"  label-width="80px" >
        <el-form-item label="标题" style="width:60%;" >
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="所在栏目">
          <el-select v-model="formParentChild" placeholder="请选择栏目" @change="getColumn(formParentChild)" >
            <el-option label="红色教育服务中心" value="0"></el-option>
            <el-option label="东北抗日义勇军纪念馆" value=1></el-option>
            <el-option label="李秋实纪念馆" value=2></el-option>
            <el-option label="桓仁抗战红都教育服务中心" value=3></el-option>
          </el-select>
          <el-select v-model="form.columnId" placeholder="请选择子栏目" style="z-index: 9999">
            <el-option v-for="item in formColumnChild" :key="item.index" :label="item.name" :value="item.id" height="100"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  label="文章来源"   style="width:20%;">
          <el-input  placeholder="请输入文章来源" v-model="form.source"></el-input>
        </el-form-item>
        <el-form-item label="作者"  style="width:20%;">
          <el-input  placeholder="请输入作者"  v-model="form.writer"></el-input>
        </el-form-item>
        <el-form-item label="视频地址"  style="width:20%;">
          <el-input  placeholder="请输入视频地址"  v-model="form.videosrc"></el-input>
        </el-form-item>

        <el-form-item label="封面图">
          <el-upload
              action="/api/common/upload"

              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="handSuccess"
              list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-button type="primary" style="margin-top: 20px;" @click="articleSubmit(form)">提交</el-button>
        <el-button type="warning" style="margin-top: 20px;" @click="restPage()">重置</el-button>
        <el-button type="danger" style="margin-top: 20px;"  @click="offPage()">取消</el-button>

      </el-form>
    </el-card>
  </div>
</template>

<script>
import {request} from "@/request/request";

export default {
  name: "ArticleVideo",
  data(){
    return {
      form: {
        title: '',
        content:'',
        source: '',
        writer: '',
        columnId: '',
        imgsrc:'',
        videosrc:'',
        abstr:'',
        type:'2'
      },
      formParentChild:"请选择活动区域",
      formColumnChild:[],
      child1:{parentId:1},
      dialogTableVisible: false,
      dialogFormVisible: false,

      formLabelWidth: '120px',
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  methods:{
    changeWang(html){
      //这里的html是带有标签的
      this.form.content=html

    },
    getColumn(data){

      var getChild = {parentId:data};
      console.log(getChild);
      this.getChildData(getChild);
    },
    articleSubmit(data){
      if(!this.form.title){
        console.log("请输入标题")
        return false
      }
      request({
        method:'POST',
        url:'/articles',
        data:data
      }).then(res =>{
        this.$message({
          type: 'success',
          message: '新增成功!',
        });
        this.$router.push({name:'articleman'});
        console.log(res);
      },err=>{
        console.log(err)
      })
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.form.imgsrc = file.url;
      this.dialogVisible = true;
    },
    handSuccess(response){
      this.form.imgsrc = response.data;
    },
    getChildData:function(data){//获取全部数据

      request({
        method:'POST',
        url:"/acolumns/allchild",
        data:data,
      }).then(res =>{
        console.log(res.data)
        this.formColumnChild = res.data;
        console.log(this.formColumnChild)
      },err=>{
        console.log(err)
      })
    },
    restPage(){
      this.form =  {
        title: '',
        content:'',
        source: '',
        writer: '',
        columnId: '',
        imgsrc:'',
        videosrc:''
      }
    },
    offPage(){
      this.$router.push({name:'articleman'});
    },
  },
  mounted() {


  }
}
</script>

<style scoped>

</style>
